<template>
  <div class="app-container" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-row style="margin-top: 20px; margin-bottom: 10px" :gutter="10" class="mb8">
      <el-col :span="3">
        <el-input size="mini" clearable v-model="param.keywords" placeholder="请输入关键字"></el-input>
      </el-col>
      <el-col :span="1.5">
        <el-button type="warning" icon="el-icon-search" size="mini" @click="GetMeetDatas">搜索</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="success" icon="el-icon-edit" size="mini" :disabled="single" @click="handleUpdate">修改
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="danger" icon="el-icon-delete" size="mini" :disabled="multiple" @click="handleDelete">删除
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="success" icon="el-icon-refresh" size="mini" @click="RefreshCover">刷新封面</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-position" size="mini" @click="MeetingRotation">会议轮播</el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="30" />
      <el-table-column prop="title" label="会议标题"> </el-table-column>
      <el-table-column prop="content_in_submission" label="会议通知">
        <template slot-scope="scope">
          <div class="cellstyle" v-html="scope.row.content_in_submission"></div>
        </template>
      </el-table-column>
      <el-table-column prop="content_registering" label="会议注册">
        <template slot-scope="scope">
          <div class="cellstyle" v-html="scope.row.content_registering"></div>
        </template>
      </el-table-column>
      <el-table-column prop="content_end" label="会议议程">
        <template slot-scope="scope">
          <div class="cellstyle" v-html="scope.row.content_end"></div>
        </template>
      </el-table-column>
      <el-table-column prop="place" label="会议地点"> </el-table-column>
      <el-table-column prop="modality" label="会议形式">
        <template slot-scope="scope">
          {{ scope.row.modality == 1 ? "线上" : "线下" }}
        </template>
      </el-table-column>
      <el-table-column prop="state" label="会议状态">
        <template slot-scope="scope">
          {{
            scope.row.state == 1
            ? "投稿中"
            : scope.row.state == 2
              ? "注册中"
              : scope.row.state == 3
                ? "进行中"
                : scope.row.state == 4
                  ? "已结束"
                  : ""
          }}
        </template>
      </el-table-column>
      <el-table-column prop="host_unit" label="主办单位"> </el-table-column>
      <el-table-column prop="organizer" label="承办单位"> </el-table-column>
      <el-table-column prop="organizer" label="是否推送">
        <template slot-scope="scope">
          {{ scope.row.is_push ? '推送中' : '' }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="journal" label="支持期刊"> </el-table-column> -->
      <el-table-column label="操作" width="120" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <!-- <i
            class="el-icon-view"
            style="color: rgb(24, 144, 255); cursor: pointer"
            @click="MeetDetails(scope.row)"
            >详情</i
          > -->
          <i class="el-icon-edit" style="color: rgb(24, 144, 255); cursor: pointer"
            @click="handleUpdate(scope.row)">修改</i>
          <i style="margin-left: 10px; color: rgb(24, 144, 255); cursor: pointer" class="el-icon-delete"
            @click="handleDelete(scope.row)">删除</i>
        </template>
      </el-table-column>
    </el-table>

    <pagination :total="total" :page.sync="param.pageNum" :limit.sync="param.pageSize" @pagination="GetMeetData" />

    <el-dialog :title="dialogTitle" :close-on-click-modal="false" :visible.sync="dialogVisible" width="70%">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm">
        <el-form-item label="会议标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入会议标题（会议名称不加年份、括号内容不展示、会议标题中不加书名号）"></el-input>
        </el-form-item>
        <el-form-item label="会议通知" prop="content_in_submission">
          <editor :minHeight="200" :height="400" v-model="form.content_in_submission"></editor>
        </el-form-item>
        <el-form-item label="会议注册" prop="content_registering">
          <editor :minHeight="200" :height="400" v-model="form.content_registering"></editor>
        </el-form-item>
        <el-form-item label="会议议程" prop="content_end">
          <editor :minHeight="200" :height="400" v-model="form.content_end"></editor>
        </el-form-item>
        <el-form-item label="投稿截止日期" prop="place">
          <el-date-picker :picker-options="pickerOptions" style="width: 100%" v-model="form.expiration_date"
            type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择会议截止日期（投稿截止日期不能大于注册截止日期）">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="注册截止日期" prop="place">
          <el-date-picker :picker-options="pickerOptions" style="width: 100%" v-model="form.register_end_time"
            type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择注册截止日期（注册截止日期不能大于会议开始日期）">
          </el-date-picker>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="会议开始时间" prop="start_time">
              <el-date-picker :picker-options="pickerOptions" style="width: 100%" v-model="form.start_time"
                type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择会议开始时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="会议结束时间" prop="end_time">
              <el-date-picker :picker-options="pickerOptions" style="width: 100%" v-model="form.end_time" type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择会议结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="会议地点" prop="place">
          <el-input v-model="form.place" placeholder="请输入会议地点（地区统一到市，不加“市”，比如：北京）"></el-input>
        </el-form-item>
        <el-form-item label="会议形式" prop="modality">
          <el-select v-model="form.modality" placeholder="请选择会议形式" style="width: 100%">
            <el-option v-for="item in modalityDataList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会议状态" prop="state">
          <el-select v-model="form.state" placeholder="请选择会议状态" style="width: 100%">
            <el-option v-for="item in StateDataList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主办单位" prop="host_unit">
          <el-input v-model="form.host_unit" placeholder="请输入主办单位"></el-input>
        </el-form-item>
        <el-form-item label="承办单位" prop="organizer">
          <el-input v-model="form.organizer" placeholder="请输入承办单位"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="期刊列表(现收录期刊)" prop="journal">
              <el-select class="mr10" style="width: 100%" v-model="valueType" filterable placeholder="请选择支持期刊"
                :loading="selectLoading" @change="Selectjournal">
                <el-input v-model="searchSelect" size="small" placeholder="请输入搜索内容">
                  <el-button slot="append" icon="el-icon-search" @click="searchSelectGet"></el-button>
                </el-input>
                <el-option label="期刊列表" :value="0"></el-option>
                <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选中支持期刊">
              <el-checkbox-group style="text-align: left" v-model="Included">
                <el-checkbox @change="(checked) => changeIncludedList(items)" style="margin-left: 0" border
                  v-for="items in IncludedList" :label="items.id" :key="items.id">{{ items.name }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支持期刊(未收录期刊)" prop="journal">
              <el-input v-model="NotIncluded" placeholder="请输入期刊名称（多个期刊请以‘、’中文顿号隔开）"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="是否推送该会议" style="text-align: left;">
          <el-radio-group @change="PushMeetingChange" v-model="form.is_push">
            <el-radio :label="1">推送</el-radio>
            <el-radio :label="0">暂不推送</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-show="Is_show_push_times" label="推送次数">
          <el-input type="number" min="1"  v-model="form.push_times"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="会议轮播" :close-on-click-modal="false" :visible.sync="MeetingRotationState" width="60%">
      <el-table ref="dragTable" class="dragTables" row-key="id" :data="MeetingRotationList" style="width: 100%">
        <el-table-column prop="advertising_id" label="会议ID">
        </el-table-column>
        <el-table-column prop="title" label="会议名称">
        </el-table-column>
        <!-- <el-table-column prop="id" label="轮播ID">
        </el-table-column> -->
        <el-table-column prop="display_order" label="轮播排序">
        </el-table-column>
        <el-table-column label="操作" align="center" width="220px">
          <template slot-scope="scope">
            <el-button style="margin-right:20px" size="mini" @click="handleEdit(scope.$index)">编辑</el-button>
            <el-tooltip effect="light" content="点击拖动排序" placement="right">
              <i class="el-icon-sort" style="font-size: 20px; cursor: pointer"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog width="30%" title="会议轮播选择" :visible.sync="innerVisible" :close-on-click-modal="false" append-to-body>
        <el-select style="width:100%" v-model="SingleMeetingRotationValue" clearable filterable remote reserve-keyword
          placeholder="请输入会议关键词" :remote-method="remoteMethod" :loading="selectLoading">
          <el-option v-for="item in SingleMeetingRotationList" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false">取 消</el-button>
          <el-button type="primary" @click="ConfirmMeetingRotation">确定会议轮播</el-button>
        </span>
      </el-dialog>
      <span slot="footer" class="dialog-footer">
        <el-button @click="MeetingRotationState = false">取 消</el-button>
        <el-button type="primary" @click="ModifyMeetingRotation">上传会议轮播</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  search_meeting,
  meeting_particulars,
  add_meeting,
  update_meeting,
  delete_meeting,
  refresh_meeting,
  search_journal_name,
  advertising_listForHomePage,
  advertising_list,
  advertising_update_slide
} from "../../api/Meeting.js";
import editor from "./editor.vue";
import Sortable from "sortablejs";
export default {
  name: "MeetingManagement",
  components: {
    editor,
  },
  data() {
    return {
      selectLoading: false,
      searchSelect: "",
      valueType: "",
      Included: [], //收录期刊
      IncludedList: [], //收录期刊
      NotIncluded: "", //未收录期刊
      options: [], //收录的期刊列表
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      form: {
        title: "",
        content_in_submission: "",
        content_registering: "",
        content_end: "",
        start_time: "",
        end_time: "",
        register_end_time: "",
        expiration_date: "",
        place: "",
        modality: "",
        state: "",
        host_unit: "",
        organizer: "",
        journal: "",
      },
      param: {
        keywords: "",
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      rules: {},
      tableData: [],
      modalityDataList: [
        {
          label: "线上",
          value: "1",
        },
        {
          label: "线下",
          value: "2",
        },
        {
          label: "线上线下",
          value: "3",
        },
      ],
      StateDataList: [
        {
          label: "投稿中",
          value: "1",
        },
        {
          label: "注册中",
          value: "2",
        },
        {
          label: "进行中",
          value: "3",
        },
        {
          label: "已结束",
          value: "4",
        },
      ],
      dialogTitle: "新增会议",
      dialogVisible: false, //新增修改弹窗状态
      dialogdetails: false, //详情弹窗状态
      detailsForm: {}, //详情表单数据
      loading: false,
      MeetingRotationState: false,//会议轮播弹窗状态
      // 内嵌会议选择弹窗状态
      innerVisible: false,
      MeetingRotationList: [],////会议轮播数据列表
      drop: null,
      MeetingRotationIndex: null,//会议轮播index
      SingleMeetingRotationValue: null,//单个会议输入框值
      SingleMeetingRotationList: [],//单个会议轮播搜索数组
      Is_show_push_times:false,//是否显示会议推送数量
    };
  },
  created() {
    this.GetMeetData()
    // search_journal_name({
    //   keywords: "",
    // }).then((res) => {
    //   this.options = res.data.list;
    // });
  },
  methods: {
    //   选中支持期刊
    Selectjournal(item) {
      if (item == 0) {
        this.$message({
          type: "info",
          message: "无法选中标题名称",
        });
        return;
      }
      this.valueType = "";
      if (this.Included.length == 0) {
        this.Included.push(item.id);
        this.IncludedList.push(item);
      } else {
        if (this.Included.includes(item.id)) {
          this.$message({
            type: "info",
            message: "该期刊已选中，无法重复选中；",
          });
        } else {
          this.Included.push(item.id);
          this.IncludedList.push(item);
        }
      }
    },
    // 取消支持期刊
    changeIncludedList(item) {
      if (item.length == 0) {
        this.Included = [];
        this.IncludedList = [];
      } else {
        this.IncludedList.forEach((el, index) => {
          if (el.id == item.id) {
            this.IncludedList.splice(index, 1);
            return;
          }
        });
      }
    },
    // 根据关键字搜索支持期刊列表
    searchSelectGet() {
      this.selectLoading = true;
      setTimeout(() => {
        search_journal_name({
          keywords: this.searchSelect,
        }).then((res) => {
          this.options = res.data.list;
          this.selectLoading = false;
        });
      }, 2000);
    },
    // 根据会议关键字搜索会议(轮播)
    remoteMethod(query) {
      this.selectLoading = true
      search_meeting({
        keywords: query,
        pageNum: 1,
        pageSize: 10,
      }).then(res => {
        this.SingleMeetingRotationList = res.data.list
        this.selectLoading = false
      })
    },
    PushMeetingChange(e){
      if(e == 1){
        this.Is_show_push_times = true
      }else{
        this.form.push_times = 0
        this.Is_show_push_times = false
      }
      // Is_show_push_times
    },
    // 会议轮播
    MeetingRotation() {
      this.MeetingRotationList = []
      advertising_listForHomePage({ "pageNum": 1, "pageSize": 4 }).then(res => {
        this.MeetingRotationList = res.data.list
        this.MeetingRotationState = true
        this.setRowSort()
      })
    },
    // 修改会议封面
    ModifyMeetingRotation() {
      let newArray = JSON.parse(JSON.stringify(this.MeetingRotationList))
      newArray.filter(item => {
        return delete item.title
      })
      advertising_update_slide({ list: newArray }).then(res => {
        if (res.code == 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.MeetingRotationState = false
        }
      })
    },
    // 编辑单个会议轮播
    handleEdit(index) {
      this.innerVisible = true
      this.MeetingRotationIndex = index
      this.SingleMeetingRotationValue = null
      this.selectLoading = false
      this.SingleMeetingRotationList = []
    },
    // 确认单个会议轮播
    ConfirmMeetingRotation() {
      let NewObj = {}
      try {
        this.SingleMeetingRotationList.forEach(item => {
          if (item.id == this.SingleMeetingRotationValue)
            throw NewObj = {
              advertising_id: item.id,
              title: item.title
            }
        })
      } catch (e) { }
      this.MeetingRotationList[this.MeetingRotationIndex] = Object.assign(this.MeetingRotationList[this.MeetingRotationIndex], NewObj)
      this.innerVisible = false
    },
    // 轮播列表托选功能
    setRowSort() {
      this.$nextTick(() => {
        this.drop = Sortable.create(
          document.querySelector(".dragTables .el-table__body-wrapper tbody"),
          {
            //这里指操作的图标，点击图标可以进行拖拽，若注释掉，则点击此行都可以进行拖拽
            handle: ".el-icon-sort",
            // onEnd(元素拖拽结束)
            onEnd: ({ newIndex, oldIndex }) => {
              this.MeetingRotationList.splice(
                newIndex,
                0,
                this.MeetingRotationList.splice(oldIndex, 1)[0]
              );
              var newArray = this.MeetingRotationList.slice(0);
              newArray.filter((item, index) => {
                return item.display_order = index + 1
              })
              this.MeetingRotationList = [];
              this.$nextTick(function () {
                this.MeetingRotationList = newArray;
              });
            },
          }
        );
      });
    },
    // 获取会议信息
    GetMeetData() {
      search_meeting(this.param).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      });
    },
    // 点击搜素// 获取会议信息
    GetMeetDatas() {
      this.param.pageNum = 1;
      this.param.pageSize = 10;
      search_meeting(this.param).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      });
    },
    // 新增
    handleAdd() {
      this.dialogTitle = "新增会议";
      this.dialogVisible = true;
      this.Included = [];
      this.IncludedList = [];
      this.NotIncluded = "";
      this.form = {}
      this.Is_show_push_times = false
    },
    // 修改
    handleUpdate(item) {
      let id = item.id || this.ids[0];
      this.Included = [];
      this.IncludedList = [];
      meeting_particulars({
        meeting_id: id,
      }).then((res) => {
        this.dialogTitle = "修改会议";
        this.dialogVisible = true;
        this.form = res;
        if(res.is_push == 1){
          this.Is_show_push_times = true
        }else{
          this.Is_show_push_times = false
        }
        var primaryjournal = res.journal;
        var clearjournal = "";
        if (primaryjournal) {
          var NotIncluded = [];
          clearjournal = primaryjournal.replace(/'/g, "");
          let journalArr = JSON.parse(clearjournal);
          journalArr.forEach((element) => {
            if (element.id) {
              this.Included.push(element.id);
              this.IncludedList.push(element);
            } else {
              NotIncluded.push(element.name);
            }
          });
          this.NotIncluded = NotIncluded.join("、");
        } else {
          this.Included = [];
          this.NotIncluded = "";
        }
      });
    },
    // 刷新会议封面
    RefreshCover() {
      this.$confirm(
        "此操作将非常消耗性能并进行长时间扥等待, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          refresh_meeting().then((res) => {
            if (res.code == 200) {
              this.loading = false;
              this.$message({
                type: "success",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
          this.loading = false;
        });
    },
    // 删除
    handleDelete(item) {
      var id;
      if (item.id) {
        id = [item.id];
      } else {
        id = this.ids;
      }
      this.$confirm("此操作将永久删除该会议, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delete_meeting({ meeting_ids: id }).then((res) => {
            if (res.code == 200) {
              this.GetMeetData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    cancel() {
      this.dialogTitle = "新增会议";
      this.dialogVisible = false;
      this.form = {};
      this.Included = [];
      this.IncludedList = [];
      this.GetMeetData();
    },
    confirm() {
      if (this.form.id) {
        let form = JSON.parse(JSON.stringify(this.form));
        // 定义为支持期刊数组
        let ArrNotIncluded = [];
        // 判断为收录的支持期刊数组处理
        if (this.NotIncluded) {
          //判断支持期刊字符串是否存在
          ArrNotIncluded = this.NotIncluded.split("、");
        } else {
          ArrNotIncluded = [];
        }

        let handlejournal = []; //处理完成的支持期刊数组
        handlejournal = handlejournal.concat(...this.IncludedList);
        ArrNotIncluded.forEach((el) => {
          handlejournal.push({
            name: el,
            id: "",
          });
        });

        if (handlejournal.length == 0) {
          form.journal = null;
        } else {
          form.journal = JSON.stringify(handlejournal);
        }
        update_meeting(form).then((res) => {
          if (res.code == 200) {
            this.cancel();
          }
        });
      } else {
        let form = JSON.parse(JSON.stringify(this.form));
        // 定义为支持期刊数组
        let ArrNotIncluded = [];
        // 判断为收录的支持期刊数组处理
        if (this.NotIncluded) {
          //判断支持期刊字符串是否存在
          ArrNotIncluded = this.NotIncluded.split("、");
        } else {
          ArrNotIncluded = [];
        }

        let handlejournal = []; //处理完成的支持期刊数组
        ArrNotIncluded.forEach((el) => {
          handlejournal.push({
            name: el,
            id: "",
          });
        });
        handlejournal = handlejournal.concat(...this.IncludedList);

        if (handlejournal.length == 0) {
          form.journal = null;
        } else {
          form.journal = JSON.stringify(handlejournal);
        }
        add_meeting(form).then((res) => {
          if (res.code == 200) {
            this.cancel();
          }
        });
      }
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
  },
};
</script>

<style>
.cellstyle {
  height: 60px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}

.el-table .cell {
  line-height: 20px;
}
</style>
  